import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentBtnDelete: {
        position: 'absolute',
        bottom: 30,
        paddingHorizontal: 25,
        width: '100%'
    },
    textBtnDelete: {
        color: '#BC1010',
        textAlign: 'center',
        textDecorationLine: 'underline',
        fontWeight: 'normal'
    }
});

export default styles;
